import { DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core";
import { CloseButton } from "./shared/CloseButton";
import React from "react";
import { useTranslate } from "react-admin";

import type { Place } from "../types/warehouse.types";
import { StorageEntityInfo } from "../types/warehouse.types";
import { DialogBase } from "./DialogBase";
import { PlaceDetailsContent } from "./PlaceDetailsContent";
import { valueTextStyle } from "./styles";

interface PlaceDetailModalProps {
  place: Place | null;
  open: boolean;
  onClose: () => void;
  storageEntities: StorageEntityInfo[];
}

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: "#fff",
    padding: theme.spacing(2, 3),
    width: "100%",
    boxSizing: "border-box",
  },
  titleText: {
    fontSize: "1.25rem",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  closeButton: {
    color: "#fff",
  },
  content: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
  },


  dateGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(1.5),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}));

export const PlaceDetailModal: React.FC<PlaceDetailModalProps> = ({ place, open, onClose, storageEntities }) => {
  const theme = useTheme();
  const translate = useTranslate();
  const classes = useStyles();
  const dynamicTextStyle = valueTextStyle(theme);

  if (!place) return null;

  // Filter the storage entities to find the ones relevant for this specific place, because we can select 
  // multiple places and use CTRL + double click to place - in this case multiple plece selected but for 
  // silgle place we have modal
  
  const relevantStorageEntities = storageEntities.filter(entity => 
    place.storage_entity_ids?.includes(entity.id)
  );

  return (
    <DialogBase
      open={open}
      DialogProps={{
        onClose: onClose,
        disableEscapeKeyDown: true,
        disablePortal: true,
        fullWidth: false,
        maxWidth: "sm",
        style: { position: "absolute" },
        BackdropProps: {
          style: {
            position: "absolute",
          },
        },
      }}
      DialogContentStyles={{ padding: 0 }}
      actions={null}
    >
      <DialogTitle className={classes.dialogTitle}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography component="div" className={classes.titleText}>
            {translate('osfc.storage_ui.place_detail.title', { address: place.address })}
          </Typography>
          <CloseButton onClick={onClose} className={classes.closeButton} />
        </div>
      </DialogTitle>
      <DialogContent className={classes.content}>
          {/* Place Information Section */}
        <PlaceDetailsContent place={place} storageEntities={relevantStorageEntities} />
        
      </DialogContent>
    </DialogBase>
  );
};
